<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_PROCESANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form
    [formGroup]="formulario"
    (ngSubmit)="onSubmit()"
    novalidate
    id="fFormularioConcepto"
    name="nomFormularioConcepto"
  >
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label
            >*
            {{ "PRODUCTOCONCEPTO.LBL_CONCEPTOFACTURACION" | translate }}</label
          >
          <div *ngIf="!planCargoConcepto">
            <p-dropdown disableTab
              id="idConceptoFacturacion"
              name="nomConceptoFacturacion"
              [options]="lisConceptos"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"

              formControlName="idConceptoFacturacion"
              (onChange)="verificarConcepto()"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && f.idConceptoFacturacion.invalid"
            >
              {{ "PRODUCTOCONCEPTO.LBL_CONCEPTOFACTURACION" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
          <div
            *ngIf="
              planCargoConcepto &&
              planCargoConcepto.idPlanCargoConceptoFacturacion
            "
          >
            <label class="falso-combo-texto">{{
              planCargoConcepto.conceptoFacturacion
            }}</label>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label
          >
            {{ "PRODUCTOCONCEPTO.LBL_CONVENIO" | translate }}</label
          >
          <div>
            <p-dropdown disableTab
              id="idConvenio"
              name="nomConvenio"
              [options]="lisConvenios"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"

              formControlName="idConvenioConcepto"
            ></p-dropdown>
            <div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4" *ngIf="!ocultarTipoDato">
        <div class="div-form">
          <label>* {{ "PRODUCTOCONCEPTO.LBL_TIPODATO" | translate }}</label>
            <p-dropdown disableTab
              id="idTipoDatoConcepto"
              name="nomTipoDatoConcepto"
              [options]="lisTipoDato"
              (onChange)="cambioTipoDato($event.value)"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"

              formControlName="idTipoDatoConcepto"
              *ngIf="!habilitarValoresPreestablecidos"
            ></p-dropdown>
          <div *ngIf="conceptoSeleccionado && (conceptoSeleccionado.codigo === conceptos.RECCRE ||
                      conceptoSeleccionado.codigo === conceptos.SEGDES ||
                      conceptoSeleccionado.codigo === conceptos.GARANTIA) ">
            <label class="falso-combo-texto">{{tipoDatoConcepto.nombre}}</label>
          </div>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idTipoDatoConcepto.invalid"
          >
            {{ "PRODUCTOCONCEPTO.LBL_TIPODATO" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
      <div
        class="col-12 md:col-4 lg:col-4"
        *ngIf="f.idTipoDatoConcepto.value && !ocultarTipoDato && !habilitarValoresPreestablecidos"
      >
        <div class="div-form">
          <label>* {{ "PRODUCTOCONCEPTO.LBL_VALOR" | translate }}</label>
          <input
            type="text"
            pInputText
            id="idValorPorcentaje"
            *ngIf="codTipoDato === 'PORC'"
            name="nomValorPorcentaje"
            formControlName="valor"
            [maxlength]="7"
            porcentaje-reactive
            [decimales]="4"
          />
          <input
            type="text"
            pInputText
            id="idNumero"
            *ngIf="codTipoDato !== 'PORC' && codTipoDato !== 'PESO'"
            name="nomNumero"
            autocomplete="off"
            formControlName="valor"
            numero-decimal-reactive
            [decimales]="6"
            [minimo]="0"
            [entero]="7"
            [maxlength]="14"
          />
          <input
            type="text"
            pInputText
            id="idPeso"
            *ngIf="codTipoDato === 'PESO'"
            name="nomPeso"
            autocomplete="off"
            formControlName="valor"
            [maxlength]="18"
            currencyMask
            [options]="{
              prefix: '$ ',
              thousands: appSettingService.separadorMiles,
              decimal: appSettingService.separadorDecimales,
              align: 'left',
              allowNegative: false,
              precision: 0
            }"
          />
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.valor.invalid"
          >
            {{ "PRODUCTOCONCEPTO.LBL_VALOR" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-2 lg:col-2" *ngIf="tieneRango">
        <div class="div-form">
          <label>* {{ "PRODUCTOCONCEPTO.LBL_DESDE" | translate }}</label>
          <input
            type="text"
            pInputText
            id="montoMinimo"
            name="nomMontoMinimo"
            autocomplete="off"
            formControlName="montoMinimo"
            numero-decimal-reactive
            [decimales]="6"
            [minimo]="0"
            [entero]="7"
            [maximo]="9999999.999999"
            [maxlength]="14"
          />
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.montoMinimo.invalid"
          >
            {{ "PRODUCTOCONCEPTO.LBL_DESDE" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-2 lg:col-2" *ngIf="tieneRango">
        <div class="div-form">
          <label>* {{ "PRODUCTOCONCEPTO.LBL_HASTA" | translate }}</label>
          <input
            type="text"
            pInputText
            id="montoMaximo"
            name="nomMontoMaximo"
            autocomplete="off"
            formControlName="montoMaximo"
            numero-decimal-reactive
            [decimales]="6"
            [minimo]="0"
            [entero]="7"
            [maximo]="9999999.999999"
            [maxlength]="14"
          />
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.montoMaximo.invalid"
          >
            {{ "PRODUCTOCONCEPTO.LBL_HASTA" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ "PRODUCTOCONCEPTO.LBL_IVA" | translate }}</label>
          <p-dropdown disableTab
            id="idTipoIva"
            name="nomTipoIva"
            [options]="lisIva"
            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"

            formControlName="idTipoIva"
            *ngIf="!habilitarValoresPreestablecidos"
          ></p-dropdown>

          <div *ngIf="conceptoSeleccionado && (conceptoSeleccionado.codigo === conceptos.RECCRE ||
                      conceptoSeleccionado.codigo === conceptos.SEGDES ||
                      conceptoSeleccionado.codigo === conceptos.GARANTIA) ">
            <label class="falso-combo-texto">{{tipoIva.nombre}}</label>
          </div>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idTipoIva.invalid"
          >
            {{ "PRODUCTOCONCEPTO.LBL_IVA" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ "PRODUCTOCONCEPTO.LBL_FORMAPAGO" | translate }}</label>
          <p-dropdown disableTab
            id="idTipoPago"
            name="nomTipoPago"
            [options]="lisTipoPago"
            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"

            formControlName="idFormaCobroConcepto"
            (onChange)="cambiarFormaPago($event.value)"
            *ngIf="!habilitarValoresPreestablecidos || (habilitarValoresPreestablecidos &&
             conceptoSeleccionado.codigo === conceptos.SEGDES)"
          ></p-dropdown>

          <div *ngIf="conceptoSeleccionado && (conceptoSeleccionado.codigo === conceptos.RECCRE ||
                      conceptoSeleccionado.codigo === conceptos.GARANTIA) ">
            <label class="falso-combo-texto">{{tipoFormaCobro.nombre}}</label>
          </div>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idFormaCobroConcepto.invalid"
          >
            {{ "PRODUCTOCONCEPTO.LBL_FORMAPAGO" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div
        class="col-12 md:col-4 lg:col-4"
        *ngIf="
          otrFormaPago && f.idFormaCobroConcepto.value === otrFormaPago.idLista
        "
      >
        <div class="div-form">
          <label
            >* {{ "PRODUCTOCONCEPTO.LBL_NUMEROMESCOBRO" | translate }}</label
          >
          <input
            type="text"
            pInputText
            id="numCuota"
            name="nomNumeroCuota"
            autocomplete="off"
            formControlName="numeroCuotaCobro"
            numero-entero-reactive
            [minimo]="1"
            [maxlength]="3"
          />
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.numeroCuotaCobro.invalid"
          >
            {{ "PRODUCTOCONCEPTO.LBL_NUMEROMESCOBRO" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <p-checkbox
            label="{{ 'LBL_HABILITADO' | translate }}"
            binary="true"
            id="indicadorHabilitado"
            name="nomIndicadorHabilitado"
            formControlName="indicadorHabilitado"
          ></p-checkbox>
        </div>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="regresarFormulario(formulario.dirty)" class="cancelar">{{
            "BTN_CANCELAR" | translate
          }}</a>
          <button
            icon="fa fa-plus"
            label="{{ 'BTN_GUARDAR' | translate }}"
            type="submit"
            pButton
          ></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
          <span>{{ "LBL_GUARDANDO" | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        [loading]="guardando"
        [value]="lisPlanCargoConceptosFacturacion"
        selectionMode="single"
        dataKey="idPlanCargoConceptosFacturacion"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.conceptoFacturacion }}</td>
            <td>{{( row.codigoConvenio
                  ? row.codigoConvenio + " - "
                  : "" )}}
                  {{ row.nombreConvenio
                  }}
            </td>
            <td>{{ row.tipoDatoConcepto }}</td>
            <td>
              {{
                row.codigoTipoDatoConcepto == "PESO"
                  ? (row.valor | dinero: 2)
                  : row.codigoTipoDatoConcepto == "PORC"
                  ? row.valor + "%"
                  : row.valor
              }}
            </td>
            <td>
              {{
                row.montoMinimo !== null &&
                row.montoMinimo !== undefined &&
                row.montoMaximo !== null &&
                row.montoMaximo !== undefined
                  ? row.montoMinimo + "-" + row.montoMaximo
                  : ""
              }}
            </td>
            <td>{{ row.tipoIva }}</td>
            <td>{{ row.formaCobroConcepto }}</td>
            <td>{{ row.numeroCuotaCobro }}</td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorHabilitado"
                binary="true"
                disabled="true"
              ></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-pencil"
                  data-toggle="tooltip"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  pButton
                  (click)="editar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cf key="concepto-facturacion">
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cf.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cf.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog #cg key="confirmar-guardado">
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cg.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cg.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
